// src/services/transactionsService.js
import api from './api'

export const fetchTransactions = async () => {
    // CHANGE THIS to your real endpoint
    // examples: '/transactions', '/user/transactions', '/wallet/transactions'
    const res = await api.get('/transactions')

    // Support common response shapes
    const data = res?.data?.data ?? res?.data?.transactions ?? res?.data ?? []
    return Array.isArray(data) ? data : []
}
